<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <!-- <li> -->
            <!--     <a (click)='analyticsService.sendAnalyticEvent("click_github", "footer", "github")' href="https://github.com/andresjosehr" target='_blank'> -->
            <!--         <i class="fab fa-github"></i> -->
            <!--     </a> -->
            <!-- </li> -->
            <!-- <li> -->
            <!--     <a (click)='analyticsService.sendAnalyticEvent("click_linkedin", "footer", "github")' href="https://www.linkedin.com/in/andresjosehr/" target='_blank'> -->
            <!--         <i class="fab fa-linkedin-in"></i> -->
            <!--     </a> -->
            <!-- </li> -->
        </ul>
        <!-- <div class="footer-right-bar d-none d-md-block"> -->
        <!--     <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "footer", "email")' href="mailto:andresjosehr@gmail.com" target='_blank'>andresjosehr&#64;gmail.com </a> -->
        <!-- </div> -->
    </div>

    <div class="footer-credits text-center" >
        <a (click)='analyticsService.sendAnalyticEvent("click_github_portfolio_andresjose", "footer", "click")' href="" target="_blank" rel="nofollow noopener noreferrer">
            <div>Für Julia mit Liebe</div>
        </a>
        <a (click)='analyticsService.sendAnalyticEvent("click_github_portfolio_brittany", "footer", "click")' href="" target="_blank" rel="nofollow noopener noreferrer">
            <div class="mt-2">Florian Huber</div>
        </a>
    </div>

</footer>
